<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.organizationName"
                append-icon="mdi-account-outline"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('organization_name_hint')"
                :label="$t('organization_name_label')"
                maxLength="50"
                outlined
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-organizationName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('organization_name_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.subOrgan"
                append-icon="mdi-domain"
                clear-icon="mdi-close-circle-outline"
                clearable
                class="contentinfo"
                counter="50"
                dense
                :hint="$t('sub_organization_hint')"
                :label="$t('sub_organization_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-subOrgan`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('sub_organization_label')"
              />
            </div>
          </v-col>

          <!--      <v-col class="pa-md-3" cols="12" md="6">-->
          <!--        <v-text-field v-model="data.userName"-->
          <!--                      append-icon="person"-->
          <!--                      clear-icon="mdi-close-circle-outline"-->
          <!--                      clearable-->
          <!--                      counter="50"-->
          <!--                      dense-->
          <!--                      hint="لطفا نام  خود را وارد کنید."-->
          <!--                      label="نام و نام خانوادگی "-->
          <!--                      maxLength="50"-->
          <!--                      outlined/>-->
          <!--      </v-col>-->

          <!--      <v-col class="pa-md-3" cols="12" md="6">-->
          <!--        <v-text-field v-model="data.workField"-->
          <!--                      append-icon="mdi-domain"-->
          <!--                      clear-icon="mdi-close-circle-outline"-->
          <!--                      clearable-->
          <!--                      counter="50"-->
          <!--                      dense-->
          <!--                      hint="لطفا شماره پروانه بهداشت خود را وارد کنید."-->
          <!--                      label="شماره پروانه "-->
          <!--                      maxLength="50"-->
          <!--                      outlined/>-->
          <!--      </v-col>-->

          <v-col class="pa-md-3" cols="12" md="6">
            <template v-for="(item, index) in data.phoneNumber">
              <div
                class="rowinfo"
                v-if="!phoneNumberText.includes(index)"
                :key="index"
              >
                <v-text-field
                  v-model="item.number"
                  clearable
                  counter="11"
                  dense
                  :hint="$t('mobile_number_hint')"
                  :label="$t('mobile_number_label')"
                  maxLength="11"
                  outlined
                  class="contentinfo"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          @click="showPhoneNumberText(index)"
                          v-on="on"
                          >mdi-phone</v-icon
                        >
                      </template>
                      {{ $t("number_label") }}
                    </v-tooltip>

                    <v-icon @click="addPhone">mdi-plus</v-icon>
                    <v-icon
                      v-if="data.phoneNumber.length > 1"
                      @click="removePhone(index)"
                      >mdi-delete</v-icon
                    >
                  </template>
                </v-text-field>
                <help-info
                  v-if="index === 0"
                  :element-name="`${serviceName}-${componentName}-data-subOrgan`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('mobile_number_label')"
                />
              </div>
              <div class="rowinfo" v-else :key="index">
                <v-text-field
                  v-model="item.text"
                  clearable
                  dense
                  :label="$t('text_label')"
                  outlined
                  class="contentinfo"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          @click="showPhoneNumberText(index)"
                          v-on="on"
                          >mdi-text</v-icon
                        >
                      </template>
                      {{ $t("text_label") }}
                    </v-tooltip>
                  </template>
                </v-text-field>
                <help-info
                  :element-name="`${serviceName}-${componentName}-item-text`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('text_label')"
                />
              </div>
            </template>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo" v-if="!showCompanyNumberName">
              <v-text-field
                v-model="data.companyNumber"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="20"
                dense
                :hint="$t('company_phone_hint')"
                :label="$t('company_phone_label')"
                maxLength="20"
                outlined
                class="contentinfo"
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        @click="showCompanyNumberName = true"
                        v-on="on"
                        >mdi-phone</v-icon
                      >
                    </template>
                    {{ $t("number_label") }}
                  </v-tooltip>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyNumber`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('company_phone_label')"
              />
            </div>
            <div class="rowinfo" v-else>
              <v-text-field
                v-model="data.companyNumberName"
                clearable
                dense
                :label="$t('text')"
                outlined
              >
                <template v-slot:append-outer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        @click="showCompanyNumberName = false"
                        v-on="on"
                        >mdi-text</v-icon
                      >
                    </template>
                    {{ $t("text") }}
                  </v-tooltip>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-companyNumberName`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('text')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.email"
                append-icon="mdi-email"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('email_hint')"
                :label="$t('email_label')"
                maxLength="50"
                outlined
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-email`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('email_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.fax"
                append-icon="mdi-domain"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('fax_hint')"
                :label="$t('fax_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-fax`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('fax_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.codePostal"
                append-icon="mdi-post"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                class="contnetinfo"
                dense
                :hint="$t('postal_code_hint')"
                :label="$t('postal_code_label')"
                maxLength="50"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-codePostal`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('postal_code_label')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="data.website"
                :rules="urlRules"
                append-icon="mdi-earth"
                clear-icon="mdi-close-circle-outline"
                clearable
                counter="50"
                dense
                :hint="$t('website_hint')"
                :label="$t('website_label')"
                maxLength="50"
                outlined
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-website`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('website_label')"
              />
            </div>
          </v-col>

          <v-col
            v-if="
              $route.name === 'qr.create.businessPage' ||
              $route.name === 'qr.name.editBpage' ||
              $route.name === 'qr.name.id.editBpage'
            "
            class="pa-md-3"
            cols="12"
            md="6"
          >
            <div class="rowinfo">
              <v-text-field
                v-model="data.copyright"
                append-icon="mdi-copyright"
                clear-icon="mdi-close-circle-outline"
                class="contentinfo"
                clearable
                counter="100"
                dense
                :hint="$t('copyright_hint')"
                :label="$t('copyright_label')"
                maxLength="100"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-copyright`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('copyright_label')"
              />
            </div>
          </v-col>
        </v-row>

        <v-card-title class="pb-0">
          {{ $t("add_more_info") }}
        </v-card-title>
        <v-divider />
        <extra-fileds v-model="data.extraFields" block />

        <v-row no-gutters>
          <v-col cols="12">
            <v-divider />
          </v-col>

          <v-col class="pa-md-3" cols="12">
            <div class="rowinfo">
              <v-textarea
                v-model="data.location"
                append-icon="mdi-map-marker"
                class="mx-0 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                :hint="$t('address_hint')"
                :label="$t('address_label')"
                outlined
                rows="3"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-location`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('address_label')"
              />
            </div>
          </v-col>

          <v-col
            class="py-3 px-md-3 d-flex align-center flex-column flex-md-row align-center"
            cols="12"
          >
            <div
              class="rowinfo flex"
              :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
            >
              <v-btn
                class="text-white flex contentinfo"
                :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
                color="indigo"
                large
                @click="showMap = true"
              >
                <v-icon color="red">mdi-map-marker</v-icon>
                {{
                  data.coordinates ? $t("edit_location") : $t("add_location")
                }}
                {{ $t("location") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-showmap`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('location_label')"
              />
            </div>
            <div
              class="rowinfo"
              :style="$vuetify.breakpoint.mobile ? 'width:100%' : ''"
            >
              <v-btn
                v-show="data.coordinates"
                class="ms-md-2 mt-2 mt-md-0"
                :style="$vuetify.breakpoint.mobile ? 'flex: 1 1 auto' : ''"
                color="red"
                large
                outlined
                @click="removeLocation"
              >
                <v-icon class="me-2">mdi-close-circle-outline</v-icon>
                {{ $t("delete_location") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-data-coordinates`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('delete_location')"
              />
            </div>
          </v-col>

          <v-col class="pa-md-3" cols="12">
            <div class="rowinfo">
              <suggest-text
                v-model="data.aboutUs"
                :label="$t('about_company_label')"
                rows="10"
                class="contentinfo"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-data-aboutUs`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('about_company_label')"
              />
            </div>
          </v-col>
        </v-row>

        <custom-popup
          v-model="showMap"
          :cons="cons"
          hide-overlay
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-map-select-address`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('select_address_on_map')"
            />
          </template>
          <v-card :loading="mapLoading" class="col-12">
            <div class="px-5">
              <v-row>
                <v-col cols="12" md="6">
                  <city-selector
                    class="contentinfo"
                    v-model="geoLocation"
                    :search-fn="
                      () => {
                        this.search();
                      }
                    "
                  ></city-selector>
                </v-col>
                <v-col class="" cols="12" md="6">
                  <div>
                    <div class="rowinfo">
                      <v-autocomplete
                        v-model="geom"
                        :items="suggests"
                        :search-input.sync="searchTitle"
                        append-icon="mdi-map-marker"
                        append-outer-icon="search"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        item-text="address"
                        item-value="geom"
                        :label="$t('search_address')"
                        class="contentinfo"
                        outlined
                        @keypress.enter="search"
                        @click:append-outer="search"
                      >
                        <template v-if="suggests.length > 0" v-slot:item="data">
                          <v-list
                            v-if="suggests.length > 0"
                            style="border-bottom: 1px solid #7e8299"
                          >
                            <v-list-item-title class="font-weight-bold mb-2">{{
                              data.item.title
                            }}</v-list-item-title>
                            <v-list-item-subtitle class="mt-2"
                              >{{ data.item.address }} , {{ data.item.region }}
                            </v-list-item-subtitle>
                          </v-list>
                        </template>
                      </v-autocomplete>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-geom`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('search_address')"
                      />
                    </div>
                  </div>
                </v-col>
              </v-row>

              <p class="mt-5 font-weight-bold">
                <span><v-icon color="red">mdi-map-marker</v-icon></span>
                {{ data.address }}
              </p>

              <mapir
                v-if="data.coordinates"
                :apiKey="apiKey"
                :center="data.coordinates"
                :zoom="zoomMap"
                class="col-md-12"
                style="width: 100%; height: 500px"
                @click="getlatLng"
              >
                <mapNavigationControl
                  :showUserLocation="true"
                  position="top-right"
                />
                <mapGeolocateControl
                  position="top-right"
                  show-user-location
                  track-user-location
                />
                <mapMarker
                  :coordinates.sync="data.coordinates"
                  color="red"
                  draggable
                  kind="marker"
                >
                  <template v-slot:marker>
                    <v-icon>mdi-map-marker</v-icon>
                  </template>
                </mapMarker>
              </mapir>
            </div>
          </v-card>
        </custom-popup>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import axios from "axios";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import IconPicker from "@/view/components/IconPicker";
import ExtraFileds from "@/view/components/Product/extraFileds";
import CitySelector from "../../components/citySelector";

export default {
  name: "factoryInfo",

  components: {
    CitySelector,
    ExtraFileds,
    IconPicker,
    SuggestText,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
  },

  props: {
    data: {
      default: {},
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "factory-info",
      extraLink: [],
      searchTitle: "",
      showMap: false,
      geom: "",
      suggests: {},
      fieldsInclude: ["qr.cardVisit", "qr.id.edit", "qr.name.edit",'qr.name.id.edit', "qr.create.models"],
      mapLoading: false,
      apiKey:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      province: [],
      city: [],
      zoomMap: 15,
      geoLocation: {
        city: undefined,
        province: undefined,
      },
      phoneNumberText: [],
      showCompanyNumberName: false,
    };
  },

  computed: {
    urlRules() {
      return [(value) => this.isURL(value) || this.$t("rule_link")];
    },
    cons() {
      return {
        title: this.$t("select_address_on_map"),
      };
    },
    getCenter() {
      return this.data.center ?? [51.420296, 35.732379];
    },
    containFields() {
      return this.fieldsInclude.includes(this.$route.name);
    },
  },

  watch: {
    geom: function (val) {
      this.getBySearch();
    },
    showMap(val) {
      if (val) {
        if (!this.data.coordinates || this.data.coordinates.length <= 0)
          this.data.coordinates = this.getCenter;
      }
    },
    geoLocation: {
      handler(val) {
        if (Object.keys(val.province).length > 0) {
          this.data.coordinates[1] = val.province.longitude;
          this.data.coordinates[0] = val.province.latitude;
          if (
            this.data.coordinate[0] !== NaN &&
            this.data.coordinate[1] !== NaN
          ) {
            this.getlatLng({
              actualEvent: {
                lngLat: {
                  lng: this.data.coordinates[1],
                  lat: this.data.coordinates[0],
                },
              },
            });
            this.zoomMap = 13;
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    search() {
      this.mapLoading = true;
      axios({
        method: "GET",
        baseURL: "https://map.ir/search/v2",
        params: { text: this.searchTitle },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.mapLoading = false;
          this.suggests = response.data.value;
          this.data.center = response.data.value.coordinates;
        })
        .finally(() => {
          this.mapLoading = false;
        });
    },
    getlatLng(e) {
      this.mapLoading = true;
      this.data.coordinates = Object.values(e.actualEvent.lngLat);
      if (!!this.data?.coordinates[0] && !!this.data?.coordinate[1]) {
        axios({
          method: "GET",
          baseURL: "https://map.ir/reverse",
          params: {
            lat: this.data.coordinates[1],
            lon: this.data.coordinates[0],
          },
          timeout: 15000,
          headers: {
            "x-api-key":
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            this.mapLoading = false;
            this.data.address = response.data.address;
          })
          .finally(() => {
            this.mapLoading = false;
          });
      }
    },
    getBySearch() {
      this.mapLoading = true;
      this.data.coordinates = this.geom.coordinates;
      if (!!this.geom.coordinatess[0] && !!this.geom.coordinates[1]) {
        axios({
          method: "GET",
          baseURL: "https://map.ir/reverse",
          params: {
            lat: this.data.coordinates[1],
            lon: this.data.coordinates[0],
          },
          timeout: 15000,
          headers: {
            "x-api-key":
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            this.mapLoading = false;
            this.data.address = response.data.address;
          })
          .finally(() => {
            this.mapLoading = false;
          });
      }
    },
    addPhone() {
      this.data.phoneNumber.push({
        number: "",
      });
    },
    removePhone(index) {
      if (this.data.phoneNumber.length == 1) {
        this.data.phoneNumber[0].number = "";
      } else console.log(this.data.phoneNumber.splice(index, 1));
    },
    addExtra() {
      this.data.extraFields.push({
        icon: "",
        name: "",
        value: "",
      });
    },
    removeExtra(index) {
      if (this.data.extraFields.length <= 1) {
        this.data.extraFields[0] = {
          icon: "",
          name: "",
          value: "",
        };
      } else {
        this.data.extraFields.splice(index, 1);
      }
    },
    removeLocation() {
      this.data.coordinates = null;
    },
    addExtraLink(index, state) {
      if (!this.extraLink[index] || !this.extraLink[index].state) {
        this.extraLink[index] = { state: true };
      } else this.extraLink[index].state = false;
      this.$forceUpdate();
    },
    showPhoneNumberText(index) {
      if (this.phoneNumberText.includes(index)) {
        let i = this.phoneNumberText.indexOf(index);
        this.phoneNumberText.splice(i, 1);
      } else this.phoneNumberText.push(index);
    },
  },
};
</script>

<style scoped></style>
